import { ComponentHeader, StyledCreate } from "@components";
import { RedeemForm } from "@modules";
import { useTranslation } from "react-i18next";

export const PageRedeemCoupon = () => {
  const { t } = useTranslation();
  return (
    <>
      <ComponentHeader title={t("page.redeem_coupon")} />
      <StyledCreate>
        <RedeemForm />
      </StyledCreate>
    </>
  );
};
